/**
 * What the privacy policy tells search engines and link previews — ONE copy, read by today's page
 * (src/pages/Privacy.tsx) and its rebuild in the new design (src/design/pavilion/pages/privacy-policy/), the way
 * src/config/aboutSeo.ts serves both about pages (PV5a, design record §7b lane A).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/privacy-policy"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so
 * each stays one line. The structured data keeps JSON-style quoted keys, which the extractor does not read (unquoted,
 * its `description:` would be read as the page's).
 */
import { PREST0_ORGANIZATION_REF } from './shellStructuredData';

export const PRIVACY_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "PrivacyPolicy",
  "name": "Privacy Policy | prest0",
  "description": "How prest0 collects, uses, stores and protects personal data, who processes it, how long it is kept, and how you can export or delete your own.",
  "url": "https://prest0.ai/privacy-policy",
  "inLanguage": "en-US",
  "isAccessibleForFree": true,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://prest0.ai/privacy-policy"
  },
  // the company that publishes it: the shell's one Organization, pointed to (src/config/shellStructuredData.ts)
  "publisher": PREST0_ORGANIZATION_REF
} as const;

/** Where search files the privacy policy, whichever address served it. */
export const PRIVACY_CANONICAL_URL = 'https://prest0.ai/privacy-policy';

/** The props both privacy policy pages hand to <SeoHead>. */
export const PRIVACY_SEO = {
  title: 'Privacy Policy: How We Collect, Use & Protect Data | prest0',
  // the tab says what search says (2026-11-03): the title without the site's name, which SeoHead adds back
  tabTitle: 'Privacy Policy: How We Collect, Use & Protect Data',
  description: 'How prest0 collects, uses, stores and protects personal data, who processes it, how long it is kept, and how you can export or delete your own.',
  keywords: 'prest0 privacy policy, Prest0n, AI employee privacy, personal data, data protection, data export, data deletion',
  canonicalUrl: PRIVACY_CANONICAL_URL,
  schemaType: 'WebPage',
  structuredData: PRIVACY_STRUCTURED_DATA,
} as const;
